import styled from "@emotion/styled";

export const TradeDetailsRow = styled.div`
  padding: 0 0 0.5rem;
  color: ${props => props.theme.font.primary.default};
  font-size: ${props => props.theme.fontSize[5]};
`;
